import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAbruf, type Seite } from '../api'
import { Karte, Merkmal, Tabelle, Zustand } from '../bausteine'

interface Kundenzeile {
  id: string
  kundennummer: string
  name: string
  kundenart: string
  ort: string | null
  gesperrt: boolean
}

export default function Kunden() {
  const [eingabe, setzeEingabe] = useState('')
  const [suche, setzeSuche] = useState('')
  const [seite, setzeSeite] = useState(0)

  const treffer = useAbruf<Seite<Kundenzeile>>(
    `/api/kunden?suchbegriff=${encodeURIComponent(suche)}&seite=${seite}&groesse=25`,
  )

  return (
    <>
      <h1>Kunden</h1>
      <p className="untertitel">
        Gesucht wird in Nachname, Firmenname und Kundennummer.
      </p>

      <form
        className="leiste"
        onSubmit={(ereignis) => {
          ereignis.preventDefault()
          setzeSeite(0)
          setzeSuche(eingabe)
        }}
      >
        <div className="feld">
          <label htmlFor="suchbegriff">Suchbegriff</label>
          <input
            id="suchbegriff"
            value={eingabe}
            onChange={(ereignis) => setzeEingabe(ereignis.target.value)}
            placeholder="Name oder Kundennummer"
            style={{ width: 280 }}
          />
        </div>
        <button type="submit" className="betont">
          Suchen
        </button>
      </form>

      <Karte>
        <Zustand
          laeuft={treffer.laeuft}
          fehler={treffer.fehler}
          leer={(treffer.daten?.inhalt ?? []).length === 0}
          leertext="Kein Kunde gefunden."
        >
          <Tabelle
            spalten={[
              { name: 'Kundennummer' },
              { name: 'Name' },
              { name: 'Art' },
              { name: 'Ort' },
              { name: 'Status' },
            ]}
          >
            {(treffer.daten?.inhalt ?? []).map((kunde) => (
              <tr key={kunde.id}>
                <td>
                  <Link to={`/kunden/${kunde.kundennummer}`}>{kunde.kundennummer}</Link>
                </td>
                <td>{kunde.name}</td>
                <td>{kunde.kundenart === 'PRIVATKUNDE' ? 'Privat' : 'Gewerbe'}</td>
                <td>{kunde.ort ?? '—'}</td>
                <td>
                  {kunde.gesperrt ? (
                    <Merkmal art="fehler">Gesperrt</Merkmal>
                  ) : (
                    <Merkmal art="gut">Aktiv</Merkmal>
                  )}
                </td>
              </tr>
            ))}
          </Tabelle>

          {treffer.daten && treffer.daten.seitenzahl > 1 && (
            <div className="leiste" style={{ marginTop: 14, marginBottom: 0 }}>
              <button disabled={seite === 0} onClick={() => setzeSeite(seite - 1)}>
                Zurück
              </button>
              <span style={{ alignSelf: 'center', color: 'var(--gedaempft)', fontSize: 13 }}>
                Seite {treffer.daten.seite + 1} von {treffer.daten.seitenzahl} ·{' '}
                {treffer.daten.gesamtzahl} Treffer
              </span>
              <button
                disabled={seite + 1 >= treffer.daten.seitenzahl}
                onClick={() => setzeSeite(seite + 1)}
              >
                Weiter
              </button>
            </div>
          )}
        </Zustand>
      </Karte>
    </>
  )
}
